import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import LoginView from '@/views/LoginView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    alias: '/',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/register',
    name: 'register',

    // route level code-splitting
    // this generates a separate chunk (register.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "register" */ '@/views/RegisterView.vue'),
  },
  {
    path: '/verify',
    name: 'verify',
    component: () => import(/* webpackChunkName: "verify" */ '@/views/VerifyView.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () =>
      import(/* webpackChunkName: "forgot-password" */ '@/views/ForgotPasswordView.vue'),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: { handlesSession: true },
    component: () => import(/* webpackChunkName: "logout" */ '@/views/LogoutView.vue'),
  },
  // The issuer sends an application's sign-in and consent here with its challenges.
  {
    path: '/oauth/login',
    name: 'oauth-login',
    meta: { handlesSession: true },
    component: () => import(/* webpackChunkName: "oauth-login" */ '@/views/OAuthLoginView.vue'),
  },
  {
    path: '/oauth/consent',
    name: 'oauth-consent',
    meta: { handlesSession: true },
    component: () => import(/* webpackChunkName: "oauth-consent" */ '@/views/OAuthConsentView.vue'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () =>
      import(/* webpackChunkName: "reset-password" */ '@/views/ResetPasswordView.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
